import { Plus } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqs = [{
    question: "Wie flexibel sind eure Mitgliedschaften wirklich?",
    answer: "Total flexibel! Bei uns gibt es keine versteckten Knebelverträge. Du kannst deine Mitgliedschaft monatlich kündigen, pausieren oder upgraden, ganz so wie es dein Projekt oder dein Workflow gerade erfordert."
  }, {
    question: "Ist der Kaffee in der Flatrate tatsächlich inklusive?",
    answer: "Na klar! Wir wissen, dass guter Kaffee der Treibstoff für kreative Ideen ist. Deshalb ist frischer Barista-Kaffee, Tee und gefiltertes Wasser in jedem Tarif ohne Aufpreis enthalten. Trink so viel du magst!"
  }, {
    question: "Kann ich Meetingräume auch kurzfristig buchen?",
    answer: "Absolut. Über unsere Mitglieder-App siehst du in Echtzeit, welche Räume gerade frei sind. Ein Klick und der Raum gehört für die nächste Stunde dir – perfekt für spontane Brainstormings oder Kundenbesuche."
  }, {
    question: "Habe ich rund um die Uhr Zugang zum Space?",
    answer: "In unseren Full-Time-Tarifen erhältst du einen digitalen Schlüssel, mit dem du 24/7 Zugang hast. Egal ob du eine Nachteule bist oder den frühen Vogel liebst: Du arbeitest dann, wenn du am produktivsten bist."
  }, {
    question: "Wie sicher ist das Internet bei euch?",
    answer: "Wir setzen auf Businessleitungen mit Highspeed-Garantie. Dein Zoom-Call bleibt stabil und deine Uploads rasend schnell."
  }];
  return <section data-section-id="21212" id="faq" className="bg-[#EEEEEE] ![padding:144px_0px_144px_0px]">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>

      {/* Header - Two Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16 md:mb-20">
        <div>
          <span className="text-sm font-semibold uppercase tracking-widest text-[#888888] mb-4 block">FAQ</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
            <span className="text-[#141414]">Noch Fragen offen?</span><br />
            <span className="text-[#888888]">Hier sind Antworten.</span>
          </h2>
        </div>
        <div className="flex items-end">
          <p className="text-lg text-[#555555] leading-relaxed">
            Hier findest du Antworten auf die häufigsten Fragen. Falls doch noch etwas unklar ist, klopfe einfach kurz an!
          </p>
        </div>
      </div>

      {/* FAQ Two Column Grid */}
<div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
  {faqs.map((faq, i) => <Accordion key={i} type="single" collapsible>
      <AccordionItem value={`item-${i}`} className="border-0 rounded-2xl bg-white/60 backdrop-blur-sm data-[state=open]:bg-white data-[state=open]:shadow-lg transition-all duration-300 hover:bg-white hover:shadow-lg overflow-hidden" data-index={i}>
        <AccordionTrigger className="group px-8 py-6 hover:no-underline [&>svg:last-child]:hidden">
          <span className="font-semibold text-base text-left text-[#141414] pr-8 leading-snug">
            {faq.question}
          </span>
          <span className="shrink-0 text-[#888888] transition-transform duration-300 group-data-[state=open]:rotate-45 group-data-[state=open]:text-[#FF6F61] ml-4">
            <Plus className="size-5" />
          </span>
        </AccordionTrigger>
        <AccordionContent className="px-8 pb-8 pt-0 text-[15px] text-[#555555] leading-relaxed">
          <div className="border-t border-[#141414]/10 pt-4">
            {faq.answer}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>)}
</div>
    </div>
  </div>
</section>;
}